import Autolinker from 'autolinker';
var autolinker = function autolinker(text) {
  return Autolinker.link(text);
};
export default autolinker;